/**
 * A identidade do admin novo: o provedor do Supabase ligado ao mesmo projeto do admin atual.
 *
 * O SISTEMA NOVO É TODO NOVO, por decisão do fundador em 19/09/2026 ("não mexer nada no fluxo
 * antigo... tudo aqui precisa ser novo"). Este app não entrega nem altera o `portal/admin.html`:
 * ele usa o mesmo Supabase, com o mesmo critério de acesso, e desenha tudo com o Chassi.
 */

// O provedor do Chassi: é ele que fala com o Supabase Auth, e a tela nunca importa o SDK.
import { SupabaseIdentityProvider } from '@complexity/auth';
// O tipo da lista fechada de ambientes da plataforma.
import type { Ambiente } from '@complexity/config';

// URL do projeto: a mesma de `portal/admin.html:3042`. É pública por natureza.
const URL_PADRAO = 'https://kwpzgdcocktskkoevisr.supabase.co';
// Chave publicável: a mesma de `portal/admin.html:3043`. "Publicável" quer dizer que ela pode ir ao
// navegador; quem protege o dado é o RLS do banco, e não o segredo desta chave.
const CHAVE_PADRAO = 'sb_publishable_SeKGbLgSik9Y5vGXw_YH8g_Ug4um4SL';

// A variável de ambiente vence o padrão, para o Supabase de homologação entrar sem mudar código.
// O padrão existe porque `.env*` fica fora do git: sem ele, um clone limpo não abriria o login.
export const URL_SUPABASE = (import.meta.env.VITE_SUPABASE_URL as string | undefined) || URL_PADRAO;
// Mesma lógica para a chave: variável primeiro, e a do admin atual como padrão.
export const CHAVE_SUPABASE =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) || CHAVE_PADRAO;

/**
 * O ambiente declarado à tela de login.
 *
 * É `prd` DE PROPÓSITO, mesmo rodando na máquina: o banco padrão é o de produção, com dado real de
 * cliente, e a faixa de ambiente não pode dizer outra coisa. Contra a homologação (porta 8010), a
 * variável `VITE_CX_AMBIENTE=hml` do `.env.hml` troca isto.
 */
export const AMBIENTE_DA_TELA: Ambiente =
  (import.meta.env.VITE_CX_AMBIENTE as Ambiente | undefined) ?? 'prd';

// O único provedor do app. Criado uma vez, na carga do módulo, para a sessão não ser lida duas vezes.
export const provedor = new SupabaseIdentityProvider({ url: URL_SUPABASE, chaveAnonima: CHAVE_SUPABASE });

// Para onde o Google devolve: a raiz deste app, que termina o login lendo a sessão da URL.
// `http://localhost:8000/**` está liberado no Auth do Supabase (medido em 19/09/2026).
export function urlDeRetorno(): string {
  // A origem vem da própria página, para servir em qualquer porta liberada sem mudar código.
  return `${window.location.origin}/`;
}
